import React, { Suspense, useState } from "react";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute, LayoutSplashScreen } from "../../../../_metronic/layout";
import { SchoolProgramContextProvider } from "./Components/ProgramDataContext";
import { ProgramBulkUpload } from "./BulkUpload/ProgramBulkUpload";
import { ProgramEdit } from "./ProgramEdit";
import { ProgramList } from "./ProgramList";

export default function SchoolProgramPage({ history }) {
  const [refetch, setRefetch] = useState(false);
  const programUIEvents = {
    newProgramButtonClick: () => {
      history.push("/school-programs/add-program");
    },
    openEditProgramPage: (id) => {
      history.push(`/school-programs/${id}/edit-program`);
    },
    openDeleteProgramDialog: (id) => {
      history.push(`/school-programs/program-list/${id}/delete-program`);
    },
    openActivateProgramDialog: (id) => {
      history.push(`/school-programs/program-list/${id}/activate-program`);
    },
    openDuplicateProgramPage: (id) => {
      history.push(`/school-programs/${id}/duplicate-program/`);
    },
    openPointsDialog: (id) => {
      history.push(`/school-programs/program-list/${id}/points`);
    },
    openEmailDialog: (id) => {
      history.push(`/school-programs/program-list/${id}/email`);
    },
    // `days` is school_program.day ("Monday" or "Monday,Wednesday"); the
    // dialog uses it to pick the default session date. "-" stands in for an
    // empty day so the route still matches.
    // `full` is the value to set: true marks the program full, false not full.
    openFullDialog: (id, full) => {
      history.push(`/school-programs/program-list/${id}/full/${full ? 1 : 0}`);
    },
    openAttendanceDialog: (id, days) => {
      history.push(
        `/school-programs/program-list/${id}/attendance/${encodeURIComponent(days || "") || "-"}`
      );
    },
    openBulkUploadPage: (id) => {
      history.push({
        pathname: `/school-programs/${id}/bulk-upload`,
        state: { programId: id },
      });
    },
    refetch: refetch,
    setRefetch: setRefetch,
  };
  return (
    <SchoolProgramContextProvider programUIEvents={programUIEvents}>
      <Suspense fallback={<LayoutSplashScreen />}>
        <Switch>
          {
            <Redirect
              exact={true}
              from="/school-programs"
              to="/school-programs/program-list"
            />
          }
          <ContentRoute
            path="/school-programs/add-program"
            component={ProgramEdit}
          />

          <ContentRoute
            path="/school-programs/:id/edit-program"
            component={ProgramEdit}
          />

          <ContentRoute
            path="/school-programs/program-list"
            component={ProgramList}
          />

          <ContentRoute
            exact
            path="/school-programs/:id/bulk-upload"
            component={ProgramBulkUpload}
          />

          <ContentRoute
            exact
            path="/school-programs/:id/:duplicate/:dest_id"
            component={ProgramEdit}
          />

          <ContentRoute
            exact
            path="/school-programs/:id/:duplicate"
            component={ProgramEdit}
          />
        </Switch>
      </Suspense>
    </SchoolProgramContextProvider>
  );
}
